import styled from '@emotion/styled';
import { SmallText } from 'ds/components/typography';

export const Root = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const Title = styled(SmallText)(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
}));
